import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPackageFilters } from '../package-filters/package-filters.component';
import { createQueryParams } from '../../utils/query-params.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PackageListingService {
  private http = inject(HttpClient);

  constructor() {}

  getAllPackageListings(queryParams: IPackageFilters): Observable<any> {
    const qParams = createQueryParams({
      ...queryParams,
    });

    return this.http.get<any>(
      `${environment.apiUrl}/api/public/packages?${qParams}`
    );
  }

  packageCompare(queryParams: any) {
    const qParams = createQueryParams(queryParams);
    return this.http.get<any[]>(
      `${environment.apiUrl}/api/website/packages-compare?${qParams}`
    );
  }
}
